import HandleErrorApi from "./HandleErrorApi";

class ClusterApi {
    api = new HandleErrorApi();

    getClusterList(data)
    {
        return this.api.get('/clustering/list', data);
    }

    getClusterHistory(uid)
    {
        return this.api.get('/clustering/' + uid + '/history');
    }

    restoreHistory(uid, data)
    {
        return this.api.post('/clustering/' + uid + '/history', data);
    }

    /**
     * Получаем данные по ключам в попап создания кластеризатора
     * @param {String} uid - uid проекта кластеризатора
     * @returns {Promise<{
     *     unknownWs: Number,
     *     unknownSerp: Number,
     *     unknownTotal: Number,
     *     totalKeys: Number,
     *     isNeedAttention: Boolean,
     *     topNumberSerpLimitsFactorRelations: Array
     * }>}
     */
    getUnknownKeys(uid) {
        return this.api.get('/clustering/' + uid + '/unknown_keys');
    }

    /**
     * Запуск процесса клатеризации
     * @param {String} uid - uid проекта кластеризатора
     * @param data
     * @returns {Promise<'true'>}
     */
    doAutoCluster(
        uid,
        data = {
            topNumber: null,
            fStrength: null,
            fIsWsk: null,
            fWsk: null,
            fIsSumWsk: null,
            fSumWsk: null,
            updateTypePhrases: null,
            region: null,
            ws_types: null,
        }
    ) {
        return this.api.post('/clustering/' + uid + '/build', data);
    }

    /**
     * Статус обновления данных
     * @param {String} uid - uid проекта кластеризатора
     * @returns {Promise<{
     *     batches: Number,
     *     batches_total: Number,
     * }>}
     */
    getParsersState(uid) {
        return this.api.get('/clustering/state-parsers/' + uid);
    }

    /**
     * Статус обработки отчета
     * @param {String} uid - uid проекта кластеризатора
     * @returns {Promise<{
     *     state: Number,
     *     progress: Number
     * }>}
     */
    getClusterState(uid) {
        return this.api.get('/clustering/state/' + uid);
    }

    /**
     * Перемещение фраз
     * @param {String} uid
     * @param data{{
     *     ids: String[],
     *     from: Number,
     *     to: Number,
     * }}
     */
    moveKeywords(uid, data) {
        return this.api.post(sprintf('clustering/node/%s/%d/keywords', uid, data.to), data);
    }

    /**
     * Добавление фраз
     * @param {String} uid
     * @param data{{
     *     targetNode: Number,
     *     keys: String[],
     * }}
     */
    addKeywords(uid, data) {
        return this.api.post(sprintf('clustering/%s/import/list', uid), data);
    }

    /**
     * Удаление проекта
     * @param {String} uid
     * @param data{{
     *     childs?: Boolean
     * }}
     * @returns {Promise<'true'>}
     */
    deleteProject(uid, data) {
        return this.api.delete(sprintf('clustering/%s', uid), data);
    }

    /**
     * Переименование проекта
     * @param {String} uid
     * @param data{{
     *     name: String,
     * }}
     */
    renameProject(uid, data) {
        return this.api.patch(sprintf('clustering/%s', uid), data);
    }

    /**
     * Количество всех фраз в проекте
     * @param {String} uid
     * @returns {Promise<{
     *     count: Number,
     * }>}
     */
    getCountKeywordsWithoutDeletedArt(uid) {
        return this.api.get(sprintf('clustering/%s/keywords_count', uid));
    }

    /**
     * Обновление частотности фраз проекта без запуска кластеризации
     * @param {String} uid - uid проекта кластеризатора
     * @param data{{
     *     ws_types: Number[],
     * }}
     * @returns {Promise<'true'>}
     */
    updateFrequency(uid, data) {
        return this.api.post(sprintf('clustering/%s/update-frequency', uid), data);
    }
}

export default new ClusterApi();
